<svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    width="24"
    viewBox="0 0 24 24"
    ><title>ANYWAYS Logo</title><g
        id="ANYWAYS Logo"
        fill="none"
        transform="rotate(180,12,12)"
        ><rect y="0" x="0" height="24" width="24" /><path
            class="primary"
            id="Combined-Shape"
            fill="#335eea"
            d="m3.5 4c-.2761.0-.5.2239-.5.5v5.293c0 .1326.0527.26.1465.353.1952.196.5118.196.707.0L6.043 7.957l3.6816 3.682a2.1523 2.1183.0 011.7794-1.049L7.457 6.543l1.6895-1.6895c.0938-.0938.1465-.2209.1465-.3535.0-.2761-.2239-.5-.5-.5H3.5zM13 14.293a2.1523 2.1183.0 01-1.418.529 2.1523 2.1183.0 01-.582-.08V20c0 .552.448 1 1 1s1-.448 1-1v-5.707z"
            transform="rotate(180 12 12)" /><path
            class="primary"
            opacity=".3"
            fill="#335eea"
            d="m7.2448 17.145 2.0017 2.0017c.093768.09377.14645.22094.14645.35355.0.27614-.22386.5-.5.5h-5.364c-.27614.0-.5-.22386-.5-.5v-5.364c0-.13261.052678-.25978.14645-.35355.19526-.19526.51184-.19526.70711.0l1.9432 1.9432 3.0284-2.5625 1.2919 1.5268z" /></g
    ><ellipse
        class="primary"
        rx="2.1523"
        ry="2.1183"
        stroke="#335eea"
        cy="12.61"
        cx="11.72"
        stroke-width="1.4226"
        fill="none" /></svg>
